import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';

export default function getRecipientsCount(
    wellViewState: RecipientWellWithFindControlViewState
): number {
    return wellViewState && wellViewState.recipients ? wellViewState.recipients.length : 0;
}
